import { CheckRollnoData } from './../class/chkrollnodata';
import { SaveStudentDetails } from './../class/SaveStudentDetails';
import { AppconfigService } from './appconfig.service';
import { ReturnStatus } from './../class/return-status';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class StudentevaluationService {

  returnstatus: ReturnStatus = new ReturnStatus();

  constructor(private httpcli: HttpClient) { }

    public loaddetails(): Promise<ReturnStatus> {
    let baseuser:  string;
    baseuser = AppconfigService.settings.apiserver.baseapiurl + 'studentdetails/loaddetails';
    return this.httpcli.post<ReturnStatus>(baseuser, null, httpOptions).toPromise();
  }

  public loadclg(map: any): Observable<ReturnStatus> {
    let baseuser:  string;
    baseuser = AppconfigService.settings.apiserver.baseapiurl + 'studentdetails/loadclg';
    return this.httpcli.post<ReturnStatus>(baseuser, map, httpOptions);
  }

  public loadclgData(map: any): Observable<ReturnStatus> {
    let baseuser:  string;
    baseuser = AppconfigService.settings.apiserver.baseapiurl + 'studentdetails/loadclgData';
    return this.httpcli.post<ReturnStatus>(baseuser, map, httpOptions);
  }

  public loadEditData(map: any): Observable<ReturnStatus> {
    let baseuser:  string;
    baseuser = AppconfigService.settings.apiserver.baseapiurl + 'studentdetails/loadedidata';
    return this.httpcli.post<ReturnStatus>(baseuser, map, httpOptions);
  }

  public savestudent(saveStudentDetails: SaveStudentDetails): Promise<ReturnStatus> {
    let baseuser:  string;
    baseuser = AppconfigService.settings.apiserver.baseapiurl + 'studentdetails/savestudent';
    return this.httpcli.post<ReturnStatus>(baseuser, saveStudentDetails, httpOptions).toPromise();
  }

  public updatestudent(saveStudentDetails: SaveStudentDetails): Promise<ReturnStatus> {
    let baseuser:  string;
    baseuser = AppconfigService.settings.apiserver.baseapiurl + 'studentdetails/updatestudent';
    return this.httpcli.post<ReturnStatus>(baseuser, saveStudentDetails, httpOptions).toPromise();
  }

  pushFileToStorage(file: File, studno: string): Promise<void> {
    
    const formdata: FormData = new FormData();
    formdata.append('file', file, studno);


   let baseuser:  string;
   baseuser = AppconfigService.settings.apiserver.baseapiurl + 'studentdetails/image';
    const req = new HttpRequest('POST', baseuser, formdata, {
      reportProgress: true,
      responseType: 'text'
    });
    return this.httpcli.request(req).toPromise().then( data => {
    }, error => {console.log(error);
      alert('Failed To Save Image !!! Update Your Details Using Existing User Login Option');
    });

  }

  pushWithoutImage(studentNo:string)
  {
    let baseuser:  string;
    baseuser = AppconfigService.settings.apiserver.baseapiurl + 'studentdetails/withoutimage?studentNo='+studentNo;
    return this.httpcli.post<ReturnStatus>(baseuser, null, httpOptions).toPromise();
 

  }


  public loadpdf(map: any): Promise<ReturnStatus> {
    let baseuser:  string;
    baseuser = AppconfigService.settings.apiserver.baseapiurl + 'studentdetails/loadpdf';
    return this.httpcli.post<ReturnStatus>(baseuser, map, httpOptions).toPromise();
  }

  public sendSuccessOTP(map: any): Promise<ReturnStatus> {
    let baseuser:  string;
    baseuser = AppconfigService.settings.apiserver.baseapiurl + 'studentdetails/sendotp';
    return this.httpcli.post<ReturnStatus>(baseuser, map, httpOptions).toPromise();
  }

  public verifySuccessOTP(map: any): Promise<ReturnStatus> {
    let baseuser:  string;
    baseuser = AppconfigService.settings.apiserver.baseapiurl + 'studentdetails/checkotp';
    return this.httpcli.post<ReturnStatus>(baseuser, map, httpOptions).toPromise();
  }

  public loadregno(map: any): Observable<ReturnStatus> {
    let baseuser:  string;
    baseuser = AppconfigService.settings.apiserver.baseapiurl + 'studentdetails/loadregno';
    return this.httpcli.post<ReturnStatus>(baseuser, map, httpOptions);
  }

  public chkmobileno(map: any): Observable<ReturnStatus> {
    let baseuser:  string;
    baseuser = AppconfigService.settings.apiserver.baseapiurl + 'studentdetails/chkmobileno';
    return this.httpcli.post<ReturnStatus>(baseuser, map, httpOptions);
  }

  public chkrollno(chkrollnodata: CheckRollnoData): Observable<ReturnStatus> {
    let baseuser:  string;
    baseuser = AppconfigService.settings.apiserver.baseapiurl + 'studentdetails/chkrollno';
    return this.httpcli.post<ReturnStatus>(baseuser, chkrollnodata, httpOptions);
  }

  public putLock(map: string): Promise<ReturnStatus> {
    let baseuser:  string;
    baseuser = AppconfigService.settings.apiserver.baseapiurl + 'studentdetails/putlock';
    return this.httpcli.post<ReturnStatus>(baseuser, map, httpOptions).toPromise();
  }

  public releaseLock(map: any): Promise<ReturnStatus> {
    let baseuser:  string;
    baseuser = AppconfigService.settings.apiserver.baseapiurl + 'studentdetails/releaselock';
    return this.httpcli.post<ReturnStatus>(baseuser, map, httpOptions).toPromise();
  }

}
